<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <b-modal
        ref="editFormModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        :title="editModalTitle"
        :static="true"
        :lazy="true"
    >
      <edit-form ref="editForm"></edit-form>

      <template #modal-footer>
        <b-row class="mt-3">
          <b-col class="">
            <button type="button" class="btn mr-1 btn-primary float-right" v-on:click="saveTemplate">Save Template</button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <section class="content">
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <b-form-group class="col-lg-12 col-md-12 col-sm-6">
            <button type="button" class="btn mr-1 btn-success" v-on:click="showEditModal({})"><i class="fas fa-plus"></i> Create</button>
          </b-form-group>
        </b-row>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :empty-text="emptyText"
                    show-empty
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    :busy="!!cancel"
                    :items="items"
                    :fields="fields"
                    :no-local-sorting="true"
                    :sort-icon-left="true"
                    @sort-changed="sortingChanged"
                >
                  <template #cell(limitsCount)="row">
                    count: {{ row.item.limits.length }}
                  </template>
                  <template #cell(actions)="row">
                    <button type="button" class="btn mr-1 btn-primary btn-xs" v-on:click="showEditModal(row.item)"><i class="fas fa-edit"></i> Edit</button>
                    <button type="button" class="btn mr-1 btn-secondary btn-xs" v-on:click="showEditModal({...row.item, id: null})"><i class="fas fa-copy"></i> Copy</button>
                    <RemoveForm :object="row.item.name"
                                message="Please confirm removing template"
                                :url="'/api/v1/limits-templates/' + row.item.id"
                                @finish="handleItemsUpdate"
                    />
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination
                    class="float-right"
                    v-model="pagination.page"
                    :total-rows="pagination.records"
                    :per-page="pagination.onPage"
                    @change="onPageChange"
                    first-number
                    last-number
                />
              </div>
            </div>

            <div class="row mt-10 mb-10">
              <div class="col-12">
                <ve-pagination
                    class="float-right"
                    :page-index="pagination.page"
                    :page-size="pagination.onPage"
                    :total="pagination.records"
                    :pagingCount="pagination.count"
                    :layout="['total', 'sizer']"
                    :pageSizeOption="pagination.pageSizeOption"
                    @on-page-size-change="onPageSizeChange"
                />
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import axios from "axios";
import {getRouteIcon, ROUTE_LIMITS} from "../../utils/routerIcons";
import EditForm from "../../components/LimitsTemplate/EditForm";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";

function getDefaultPagination() {
  return {
    onPage: 10,
    page: 1,
    records: 0,
    count: 0,
    pageSizeOption: [10,25,50,100,200],
  };
}

function getDefaultFilters() {
  return {
  };
}

export default {
  components: {
    EditForm,
    RemoveForm
  },
  data() {
    return {
      editModalTitle: null,
      cancel: null,
      error: null,
      filters: getDefaultFilters(),
      fields: [
        { key: 'name', label: 'Name', },
        { key: 'limitsCount', label: 'Limits', },
        { key: 'actions', label: 'Actions', thStyle: {'width': '300px'}}
      ],
      items: [],
      sortBy: null,
      sortDesc: null,
      pagination: getDefaultPagination(),
    }
  },
  watch: {
  },
  computed: {
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error.toString();
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_LIMITS),

  },
  methods: {
    saveTemplate() {
      this.$refs.editForm.isValid().then(result => {
        if (!result) {
          return;
        }

        let data = this.$refs.editForm.getData();

        this
            .$http({
              url: data.id === null ? '/api/v1/limits-templates' : '/api/v1/limits-templates/' + data.id,
              data: {
                ...data,
              },
              method: data.id === null ? 'POST' : 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$refs.editFormModal.hide();
              }, 500);

              this.$toastr.i('Success');
              this.loadItems();
            })
            .catch((err) => {
              this.$toastr.e(JSON.stringify(err.response.data.message));

              throw err;
            });

      })

    },
    showEditModal(data) {
      if (data.id) {
        this.editModalTitle = 'Edit template';
      } else {
        this.editModalTitle = 'Create template';
      }
      this.$refs.editFormModal.$root.$on('bv::modal::shown', () => {
        this.$refs.editForm.setData(data)
      })
      this.$refs.editFormModal.show();
    },
    clearFilters() {
      this.filters = getDefaultFilters();
      this.sortingChanged({
        sortBy: null,
        sortDesc: null
      })
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.pagination.page = 1;

      this.loadItems();
    },
    handleItemsUpdate() {
      this.loadItems();
    },
    loadItems: function () {
      this.items = [];

      let self = this;
      const params = {
        limit: this.pagination.onPage,
        offset: this.pagination.onPage * (this.pagination.page - 1),

        orderBy: this.sortBy,
        direction: this.sortDesc ? 'DESC' : 'ASC',
      };

      this
          .$http({
            url: '/api/v1/limits-templates',
            params: params,
            method: 'GET',
            cancelToken: new axios.CancelToken(c => { self.cancel = c; })
          })
          .then(resp => {
            let {items, pagination: {limit, totalCount}} = resp.data;

            this.items = items;
            this.pagination.onPage = limit;
            this.pagination.records = totalCount;
          })
          .catch((err) => {
            this.items = [];
            this.error = err;
          })
          .finally(() => {
            this.cancel = null;
          });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
    onFinishEdit() {
      this.loadItems();
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>
